import React from "react";
import { useNavigate } from "react-router-dom";

export default function HeaderBar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/admin/login");
  };

  return (
    <div className="bg-white shadow p-4 flex justify-between items-center">
      <h2 className="font-bold text-lg">Admin Dashboard</h2>
      <button
        onClick={handleLogout}
        className="text-sm text-gray-600 hover:text-red-600"
      >
        Logout
      </button>
    </div>
  );
}
